import { FC } from 'react';
import {
  cvaFreeParking,
  cvaFreeParkingInner,
  cvaFreeParkingTitle,
  cvaFreeParkingTitleBox,
  cvaFreeParkingAddress,
  cvaFreeParkingSpaces,
  // cvaFreeParkingButtons,
  // cvaFreeParkingButton,
} from '~/widgets/FreeParking/FreeParkingStyles';
import Close from 'public/icons/close.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { Button } from '~/shared/ui/Button/Button';
//import { useFreePlacesStore } from '~/shared/store/freeParkingPlaces';
import { wordEnding } from '~/shared/utils/wordEnding';
import {
  cvaFreeParkingBadge,
  cvaFreeParkingBadges,
  cvaFreeParkingBox,
  cvaFreeParkingText,
} from './FreeParkingContent/FreeParkingStyles';
import { priceFormatter } from '~/shared/utils/priceFormatter';
import { Parking } from '~/shared/API/response-types/parkings.types';
import { LoadingSpinner } from '~/shared/ui/LoadingSpinner/LoadingSpinner';

interface Props {
  close: (str: 'none') => void;
  openPayment: (id: string | number) => void;
  id: string | number;
  parking: Parking | undefined;
  openStartDate: (isOpen: boolean) => void;
  isScrollingHandler: (isScroll: boolean) => void;
  openDescription: boolean;
  setOpenDescription: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FreeParking: FC<Props> = ({
  close,

  parking,
  // openPayment,
  // openStartDate,

  // openDescription,
  // setOpenDescription,
}) => {
  // const openStartDateHandler = (isOpen: boolean) => {
  //   close('none');
  //   openStartDate(isOpen);
  // };

  return (
    <>
      <div className={cvaFreeParking()}>
        {!parking ? (
          <LoadingSpinner />
        ) : (
          <div className={cvaFreeParking()}>
            <div className={cvaFreeParkingInner()}>
              <div>
                <div className={cvaFreeParkingTitleBox()}>
                  <h3 className={cvaFreeParkingTitle()}>{parking?.name}</h3>
                  <Button
                    icon={<Close className={cvaIcon({ iconSize: 'common' })} />}
                    onlyIcon
                    onClick={() => close('none')}
                  />
                </div>
                {parking?.location?.formatted_address && (
                  <p
                    className={cvaFreeParkingAddress()}
                    dangerouslySetInnerHTML={{
                      __html: parking.location.formatted_address,
                    }}></p>
                )}

                {typeof parking?.free_spaces == 'number' && (
                  <div
                    className={cvaFreeParkingSpaces({
                      active: parking?.free_spaces > 0,
                    })}>
                    {parking.free_spaces}{' '}
                    {wordEnding(parking.free_spaces, [
                      'свободное место',
                      'свободных места',
                      'свободных мест',
                    ])}
                  </div>
                )}
              </div>
              {/* <RentalPeriod openStartDate={openStartDateHandler} /> */}
            </div>
            <div className={cvaFreeParkingBox()}>
              <p className={cvaFreeParkingText()}>
                Открыта{' '}
                {parking?.is_around_the_clock ? 'круглосуточно' : 'до 23:00'}
              </p>
              {parking?.min_hourly_price && (
                <p className={cvaFreeParkingText()}>
                  <span>
                    от {priceFormatter(parking?.min_hourly_price)}/час
                  </span>
                </p>
              )}
              <div className={cvaFreeParkingBadges()}>
                {parking?.type_label && (
                  <div className={cvaFreeParkingBadge()}>
                    {parking?.type_label}
                  </div>
                )}
                {parking?.location_type_label && (
                  <div className={cvaFreeParkingBadge()}>
                    {parking?.location_type_label}
                  </div>
                )}
                {parking?.construction_type_label && (
                  <div className={cvaFreeParkingBadge()}>
                    {parking?.construction_type_label}
                  </div>
                )}
              </div>
            </div>
            {/* <div className={cvaFreeParkingButtons()}>
              <div
                className={cvaFreeParkingButton({ active: openDescription })}
                onClick={() => setOpenDescription(true)}>
                Описание
              </div>
              <div
                className={cvaFreeParkingButton({ active: !openDescription })}
                onClick={() => setOpenDescription(false)}>
                Аренда
              </div>
            </div> */}
            {/* <FreeParkingPlacesList
              id={id}
              openPayment={openPayment}
              ref={scrollRef}
              isScrolling={isScrolling}
            /> */}
          </div>
        )}
      </div>
    </>
  );
};
